import React from "react";
const SessionContext = React.createContext(undefined);
export default SessionContext;
